import React from 'react';
import { StyledSvg } from 'icons';
import { color as designColor } from '@design/templateFns';
import styled, { css } from 'styled-components';

interface SignetProps {
  fillColor?: string;
  size?: string;
}

export const Signet = ({
  fillColor = designColor('fg')(), // whatever fillColor is passed in will be the 'Engels' and 'Volkers' color
  size = '100px',
}: SignetProps) => {
  const evRed = designColor('cta')();

  return (
    <SignetWrapper $size={size}>
      <StyledSvg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 21"
        x="0"
        y="0"
        width="48"
        height="21"
        scale={1}
        color={fillColor}
      >
        <g clip-path="url(#clip0_7921_14701)">
          <path
            fill={fillColor}
            d="M0 0.545166H13.9669V3.32768H3.03451V9.05215H12.3559V11.8347H3.03451V18.2175H14.21V21H0V0.545166Z"
          />
          <path
            fill={evRed}
            d="M26.5404 11.7524C26.9153 10.8266 27.1028 9.70536 27.1028 8.39897H29.3064C29.3064 10.3791 28.9062 12.0456 28.0957 13.388C28.4554 13.7325 28.8049 13.9691 29.1443 14.0977C29.4838 14.2263 29.889 14.288 30.3551 14.288H30.8921V16.3608H30.4615C30.0157 16.3608 29.6205 16.3453 29.2811 16.3042C28.9417 16.2682 28.6276 16.1962 28.3388 16.0882C28.0501 15.9802 27.7816 15.8362 27.5334 15.651C27.2851 15.471 27.0116 15.2395 26.7279 14.9669C25.4766 16.0213 23.8555 16.5511 21.8645 16.5511C20.1117 16.5511 18.749 16.1447 17.7814 15.3373C16.8138 14.5298 16.3325 13.3879 16.3325 11.917C16.3325 10.8832 16.5959 9.98824 17.1228 9.24247C17.6497 8.49669 18.5159 7.80749 19.7166 7.16973C19.1796 6.53196 18.7895 5.93534 18.5463 5.36958C18.3032 4.80382 18.1816 4.23292 18.1816 3.65173C18.1816 2.56135 18.5463 1.68185 19.2809 1.00808C20.0155 0.334313 20.9831 0 22.1837 0C23.3843 0 24.3519 0.32917 25.0865 0.982366C25.8211 1.63556 26.1858 2.50992 26.1858 3.60029C26.1858 4.41808 25.9426 5.14842 25.4614 5.78104C24.9801 6.41881 24.1797 7.05143 23.0702 7.6892L26.5354 11.7524H26.5404ZM21.0084 8.67157C20.2384 9.07274 19.6811 9.50992 19.3316 9.9831C18.982 10.4563 18.8098 11.0118 18.8098 11.6444C18.8098 12.5547 19.134 13.2645 19.7774 13.784C20.4208 14.3035 21.282 14.5606 22.3559 14.5606C23.5009 14.5606 24.4583 14.2417 25.2283 13.604L21.0135 8.66642L21.0084 8.67157ZM21.8392 6.24394C22.6092 5.82733 23.1462 5.42616 23.4502 5.04556C23.7542 4.66495 23.9061 4.2072 23.9061 3.68259C23.9061 3.1014 23.7592 2.65907 23.4654 2.36076C23.1716 2.06245 22.7511 1.9133 22.2141 1.9133C21.6771 1.9133 21.2516 2.05217 20.9375 2.33505C20.6234 2.61793 20.4663 3.01396 20.4663 3.52314C20.4663 3.90375 20.5677 4.30492 20.7754 4.72153C20.9831 5.13813 21.3326 5.64732 21.8342 6.24908L21.8392 6.24394Z"
          />
          <path
            fill={fillColor}
            d="M30.2993 0.545166H33.577L39.2458 17.59L44.9096 0.545166H47.9998L40.9885 21H37.3359L30.2993 0.545166Z"
          />
        </g>
        <defs>
          <clipPath id="clip0_7921_14701">
            <rect width="48" height="21" />
          </clipPath>
        </defs>
      </StyledSvg>
    </SignetWrapper>
  );
};

export const SignetWrapper = styled.div<{ $size: string }>`
  //check if size is passed, if not, use 100%
  width: ${({ $size }) => ($size ? $size : '100%')};

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;
